import React from 'react'

import { Box, Typography } from "@mui/material"
import { truncateString } from "@utils"
import { TooltipSeeker } from "@ui-seeker/core"


export default function carModelColumn() {

	return {
		name: 'model',
		label: 'Car Model',
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: value => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", ml: 1 }}>
				<TooltipSeeker title={value?.length > 30 && value}>
					<Typography>{truncateString(value || "", 30) || "Any"}</Typography>
				</TooltipSeeker>
			</Box>,
		}
	}
}